import { render, staticRenderFns } from "./inputChangeCategorias.vue?vue&type=template&id=874f3334&scoped=true&"
import script from "./inputChangeCategorias.vue?vue&type=script&lang=js&"
export * from "./inputChangeCategorias.vue?vue&type=script&lang=js&"
import style0 from "./inputChangeCategorias.vue?vue&type=style&index=0&id=874f3334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874f3334",
  null
  
)

export default component.exports